module.exports = __webpack_public_path__ + "static/media/a-3.712e758f.jpg";